import React, { useMemo } from 'react';
import {
  PriceRow,
  PriceInfo,
  Label,
  InfoIconContainer,
  AmountWrapper,
  HeadlineOrder3,
  HeadlineOrder4,
} from './PriceBreakdown-T3.styles';
import { COLORS } from '../../styles/variables';
import InfoIcon from '../../assets/icons/Info';

interface BreakdownRowProps {
  priceKey: string;
  label: string;
  priceValue: string;
  labelVariant?: string;
  isMain?: boolean;
  shortDisclaimer?: string;
  longDisclaimer?: string;
  hasIndent?: boolean;
  noBottomBorder?: boolean;
  onModalOpen: (e: React.MouseEvent, text: string) => void;
}

const BreakdownRow: React.FC<BreakdownRowProps> = ({
  priceKey,
  label,
  priceValue,
  labelVariant,
  isMain,
  shortDisclaimer,
  longDisclaimer,
  hasIndent,
  noBottomBorder,
  onModalOpen,
}) => {
  const formattedLabel = useMemo(() => {
    if (labelVariant === 'h3') {
      return <HeadlineOrder3 isbold>{label}</HeadlineOrder3>;
    }
    if (labelVariant === 'h4') {
      return <HeadlineOrder4 isbold>{label}</HeadlineOrder4>;
    }
    return <Label>{label}</Label>;
  }, [label, labelVariant]);

  return (
    <PriceRow
      className={hasIndent ? 'hasIndent' : ''}
      hasIndent={hasIndent}
      noBottomBorder={noBottomBorder}
      key={priceKey}
      alignItems={isMain ? 'center' : ''}
    >
      <PriceInfo>
        {formattedLabel}
        {!!shortDisclaimer?.length && <Label color={COLORS.grey60}>{shortDisclaimer}</Label>}
      </PriceInfo>
      <AmountWrapper>
        <Label isBold={isMain} color={COLORS.black}>
          {priceValue}
        </Label>
        {!!longDisclaimer?.length && (
          <InfoIconContainer onClick={(e) => onModalOpen(e, longDisclaimer || '')}>
            <InfoIcon color={COLORS.grey60} size={24} />
          </InfoIconContainer>
        )}
      </AmountWrapper>
    </PriceRow>
  );
};

export default BreakdownRow;
